import { CardContent, Box, Typography } from '@mui/material';
import { StyledCard } from './CardStyles';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface QuickActionCardProps {
  title: string;
  icon: ReactNode;
  to: string;
}

export default function QuickActionCard({ title, icon, to }: QuickActionCardProps) {
  const navigate = useNavigate();

  return (
    <StyledCard onClick={() => navigate(to)} role="link" tabIndex={0}>
      <CardContent sx={{ py: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box sx={{ '& svg': { fontSize: 48 }, color: 'primary.main', mb: 1 }}>{icon}</Box>
        <Typography variant="h6" align="center">
          {title}
        </Typography>
      </CardContent>
    </StyledCard>
  );
}
